import React from 'react';

export const ENTITY_NOT_FOUND = 'ENTITY_NOT_FOUND';
export const INSUFFICIENT_REQUEST = 'INSUFFICIENT_REQUEST';
export const ENTITY_ALREADY_EXISTS = 'ENTITY_ALREADY_EXISTS';
export const EXTERNAL_SERVICE_ERROR = 'EXTERNAL_SERVICE_ERROR';
export const PERSISTENCE_SERVICE_ERROR = 'PERSISTENCE_SERVICE_ERROR';

export const ENTITY_ALREADY_EXISTS_CONFLICT_MESSAGES = {
  'email': 'Email already registered.',
};
